module.exports = __webpack_public_path__ + "img/logo-white.37e209e8.png";